export const theme = (th: any) => ({
  ...th,
  borderRadius: "2px",
  borderWidth: "0px",
  padding: "0px",
  colors: {
    ...th.colors,
    primary: "#14aa40",
    primary25: "#E4EDDE",
    primary50: "#E4EDDE",
    danger: "#B54040",
    neutral20: "#E4E4E4",
    neutral30: "#14aa40",
    neutral40: "#14aa40",
    neutral50: "#231f20"
  }
});

export const customStyling = {
  option: (provided: any, state: any) => ({
    ...provided,
    margin: "2px",
    backgroundColor: state.isSelected || state.isFocused ? "#E4EDDE" : "#FFF",
    color: state.isSelected || state.isFocused ? "#14aa40" : "#231f20",
    fontWeight: state.isSelected || state.isFocused ? 700 : 400,
    ":hover": {
      color: "#14aa40",
      fontWeight: "700"
    },
    ...state?.data?.isClearOption && {
      backgroundColor: "#f1f2f2",
      borderBottom: "2px solid #d2d2d2",
      color: "#6e6e6e"
    }
  }),
  control: (provided: any) => ({
    ...provided,
    borderWidth: "2px",
    boxShadow: 0
  }),
  indicatorSeparator: (provided: any) => ({
    ...provided
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#6E6E6E"
  }),
  input: (provided: any) => ({
    ...provided,
    paddingBottom: "0px",
    paddingTop: "0px",
    margin: "0px",
    fontWeight: "700"
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: "0px 8px",
    fontWeight: "700"
  }),
  singleValue: (provided: any, state: any) => ({
    ...provided,
    color: state.data.value === "default" ? "#6E6E6E" : provided.color
  }),
  menu: (provided: any) => ({
    ...provided,
    border: "2px solid #14aa40",
    marginTop: "-2px",
    zIndex: "40",
    overflowX: "hidden"
  }),
  menuList: (provided: any) => ({
    ...provided,
    overflowX: "hidden"
  })
};